import { render, staticRenderFns } from "./product-hero-carousel.vue?vue&type=template&id=3769147e&scoped=true"
import script from "./product-hero-carousel.vue?vue&type=script&lang=js"
export * from "./product-hero-carousel.vue?vue&type=script&lang=js"
import style0 from "./product-hero-carousel.vue?vue&type=style&index=0&id=3769147e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769147e",
  null
  
)

export default component.exports